import { render } from "./PublishButton.vue?vue&type=template&id=240f9587"
import script from "./PublishButton.vue?vue&type=script&lang=js"
export * from "./PublishButton.vue?vue&type=script&lang=js"

import "./PublishButton.vue?vue&type=style&index=0&id=240f9587&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__